import { useClientMute, muteTooltip, UNVERIFIED_BOOKING_REASON } from "./useClientMute";

/**
 * Pastille « Client en sourdine » des en-têtes (modale ordre, fiche ordre, dossier).
 * N'affiche rien quand le client reçoit ses notifications. Même source et même
 * action que le chat (useClientMute) : les deux restent synchrones.
 */
export default function ClientMuteBadge({ discussionId }: { discussionId?: string | null }) {
  const { state, busy, setMuted } = useClientMute(discussionId);
  if (!state?.muted) return null;
  // Réservation en ligne sans reCAPTCHA : la sourdine EST la validation en attente.
  const unverified = state.muted_reason === UNVERIFIED_BOOKING_REASON;
  return (
    <span
      className="inline-flex flex-row items-center gap-1.5 rounded-full pl-2.5 pr-1 py-0.5"
      style={{ background: "#FFFBEB", border: "1px solid #FCD34D", whiteSpace: "nowrap" }}
      title={muteTooltip(state)}
    >
      <svg width={13} height={13} viewBox="0 0 24 24" fill="none" stroke="#B45309" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
        <path d="M16.5 8.5a5 5 0 0 1 .5 2.2V13m-2 4H6a2 2 0 0 1-1.6-3.2C5.5 12.4 6 11 6 9.3a6 6 0 0 1 8-5.6" />
        <line x1="3" y1="3" x2="21" y2="21" />
      </svg>
      <span className="text-h4 font-semibold" style={{ color: "#92400E" }}>
        {unverified ? "Réservation non vérifiée" : "Client en sourdine"}
      </span>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); setMuted(false); }}
        disabled={busy}
        className="text-h5 font-semibold rounded-full px-2 py-0.5 hover:bg-amber-100 transition-colors disabled:opacity-40"
        style={{ color: "#92400E" }}
        title={unverified
          ? "La demande est légitime : la confirmation retenue part au client, puis ses rappels et messages"
          : "Le client recevra de nouveau confirmations, rappels et messages"}
      >
        {unverified ? "Valider et envoyer la confirmation" : "Réactiver les notifications"}
      </button>
    </span>
  );
}
